export const PASSWORD_RESET_REQUESTED = 'PASSWORD_RESET_REQUESTED';
export const PASSWORD_RESET_REQUEST_FAILED = 'PASSWORD_RESET_REQUEST_FAILED';
